import Dexie from 'dexie'
import { AsyncCache, debug } from '@dinosband/dbi-utils'
import { Message } from './types'

interface DbItem {
  id: number
  chatRoomId: number
  mesg: Message
}

//--------------------------------------------------------------------------
// MessageCacheDB
//--------------------------------------------------------------------------
class MessageCacheDB extends Dexie {
  items!: Dexie.Table<DbItem, string>

  constructor (dbName: string) {
    super(dbName)
    this.version(1).stores({
      items: 'id,chatRoomId',
    })
  }
}

export class MessageCacheIndexedDBDriver {
  protected dbName: string
  protected db: MessageCacheDB
  // dbItems: DbItem[] | undefined = undefined
  loader: AsyncCache<string, DbItem[]>

  constructor (dbName: string) {
    this.dbName = dbName
    this.db = new MessageCacheDB(dbName)
    this.loader = new AsyncCache<string, DbItem[]>(1)
  }

  async deleteDatabases (prefix: string) {
    Dexie.getDatabaseNames().then(async (databases) => {
      for (const db of databases) {
        if (db.startsWith(prefix)) {
          await Dexie.delete(db)
        }
      }
    })
  }

  async reset (): Promise<void> {
    await this.db.items.clear()
  }

  async load (chatRoomId: number) {
    const key = `${this.dbName}-db-items`
    const dbItems = await this.loader.get(key, async () => {
      const tick = Date.now()
      const items = await this.db.items.toArray()
      debug.log(`---[[MesgCache[${this.dbName}].load]] chatRoomId = ${chatRoomId}, tick = `, Date.now() - tick)
      return items
    })
    // if (!this.dbItems) {
    //   const tick = Date.now()
    //   this.dbItems = await this.db.items.toArray()
    //   debug.log('[[MesgCache.load]] tick = ', Date.now() - tick)
    // }
    // const items = await this.db.items.where({ chatRoomId }).toArray()
    // const tick = Date.now()
    if (dbItems) {
      const items = dbItems.filter((item) => item.chatRoomId === chatRoomId)
      /*
      const newDbItems = dbItems.filter((item) => item.chatRoomId !== chatRoomId)
      this.loader.set(key, newDbItems)
      */

      return items.map((item) => item.mesg)
    } else {
      return []
    }
  }

  async put (mesgs: Message[], chatRoomId?: number): Promise<void> {
    const items: DbItem[] = mesgs.map((mesg) => ({
      id: mesg.id,
      chatRoomId: chatRoomId || mesg.chatRoomId,
      mesg,
    }))
    await this.db.items.bulkPut(items)
  }

  async delete (mesgs: Message[]): Promise<void> {
    const keys = mesgs.map((mesg) => mesg.id).map((i) => String(i))
    await this.db.items.bulkDelete(keys)
  }
}
